{
    "name": "project-template",
    "version": "0.0.0",
    "license": "MIT",
    "scripts": {
        "ng": "ng",
        "start": "node generate-git-version-info.js && ng serve --hmr",
        "format": "npx prettier . --write",
        "build": "node generate-git-version-info.js && ng build",
        "build:stats": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --stats-json",
        "analyze": "webpack-bundle-analyzer -p 5678 dist/project-template/stats.json",
        "extract-i18n": "ngx-translate-extract -i ./src -o ./src/assets/i18n/en.json -o ./src/assets/i18n/sl.json --sort --null-as-default-value  --cache-file --format json && prettier --write \"src/assets/i18n/*.json\"",
        "test": "ng test",
        "lint": "eslint --ext .ts,.html ./src",
        "e2e": "ng e2e"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^20.2.2",
        "@angular/common": "^20.2.2",
        "@angular/compiler": "^20.2.2",
        "@angular/core": "^20.2.2",
        "@angular/forms": "^20.2.2",
        "@angular/localize": "^20.2.2",
        "@angular/platform-browser": "^20.2.2",
        "@angular/platform-browser-dynamic": "^20.2.2",
        "@angular/router": "^20.2.2",
        "@microsoft/signalr": "^9.0.6",
        "@ng-icons/bootstrap-icons": "^32.1.0",
        "@ng-icons/core": "^32.1.0",
        "@ng-icons/font-awesome": "^32.1.0",
        "@ngneat/query": "^3.3.0",
        "@ngneat/query-devtools": "^2.1.0",
        "@ngneat/subscribe": "4.0.0",
        "@ngx-loading-bar/core": "^7.0.0",
        "@ngx-translate/core": "^17.0.0",
        "@ngx-translate/http-loader": "^17.0.0",
        "@progress/kendo-angular-buttons": "^20.0.2",
        "@progress/kendo-angular-common": "^20.0.2",
        "@progress/kendo-angular-conversational-ui": "^20.0.2",
        "@progress/kendo-angular-dateinputs": "^20.0.2",
        "@progress/kendo-angular-dialog": "^20.0.2",
        "@progress/kendo-angular-dropdowns": "^20.0.2",
        "@progress/kendo-angular-editor": "^20.0.2",
        "@progress/kendo-angular-excel-export": "^20.0.2",
        "@progress/kendo-angular-grid": "^20.0.2",
        "@progress/kendo-angular-icons": "^20.0.2",
        "@progress/kendo-angular-indicators": "^20.0.2",
        "@progress/kendo-angular-inputs": "^20.0.2",
        "@progress/kendo-angular-intl": "^20.0.2",
        "@progress/kendo-angular-l10n": "^20.0.2",
        "@progress/kendo-angular-label": "^20.0.2",
        "@progress/kendo-angular-layout": "^20.0.2",
        "@progress/kendo-angular-listview": "^20.0.2",
        "@progress/kendo-angular-menu": "^20.0.2",
        "@progress/kendo-angular-navigation": "^20.0.2",
        "@progress/kendo-angular-pager": "^20.0.2",
        "@progress/kendo-angular-pdf-export": "^20.0.2",
        "@progress/kendo-angular-popup": "^20.0.2",
        "@progress/kendo-angular-progressbar": "^20.0.2",
        "@progress/kendo-angular-toolbar": "^20.0.2",
        "@progress/kendo-angular-tooltip": "^20.0.2",
        "@progress/kendo-angular-treeview": "^20.0.2",
        "@progress/kendo-angular-upload": "^20.0.2",
        "@progress/kendo-angular-utils": "^20.0.2",
        "@progress/kendo-data-query": "1.7.1",
        "@progress/kendo-drawing": "1.21.2",
        "@progress/kendo-licensing": "1.7.1",
        "@progress/kendo-svg-icons": "4.5.0",
        "@progress/kendo-theme-core": "12.0.0",
        "@progress/kendo-theme-default": "12.0.0",
        "@tailwindcss/postcss": "^4.1.12",
        "@tanstack/query-core": "5.85.5",
        "@tanstack/query-devtools": "5.84.0",
        "core-js": "^3.45.1",
        "date-fns": "^4.1.0",
        "flag-icons": "^7.2.3",
        "fuse.js": "^7.0.0",
        "lodash": "^4.17.21",
        "ngx-json-viewer": "^3.2.1",
        "ngx-spinner": "^19.0.0",
        "ngx-toastr": "^19.0.0",
        "rxjs": "^7.8.2",
        "tailwind-merge": "^3.3.1",
        "zone.js": "~0.15.1"
    },
    "devDependencies": {
        "@angular-eslint/eslint-plugin": "^20.2.0",
        "@angular-eslint/eslint-plugin-template": "^20.2.0",
        "@angular-eslint/template-parser": "^20.2.0",
        "@angular/build": "^20.2.1",
        "@angular/cli": "^20.2.1",
        "@angular/compiler-cli": "^20.2.2",
        "@eslint/js": "^9.34.0",
        "@types/jasmine": "~5.1.4",
        "@types/lodash": "^4.17.7",
        "@types/node": "^24.3.0",
        "@typescript-eslint/eslint-plugin": "^8.41.0",
        "@typescript-eslint/parser": "^8.41.0",
        "@typescript-eslint/type-utils": "^8.41.0",
        "@typescript-eslint/utils": "^8.41.0",
        "@vendure/ngx-translate-extract": "^10.0.1",
        "eslint": "^9.34.0",
        "eslint-config-prettier": "^10.1.8",
        "eslint-plugin-import": "^2.29.1",
        "eslint-plugin-jsdoc": "^54.1.1",
        "globals": "^16.3.0",
        "jasmine-core": "^5.9.0",
        "karma": "~6.4.4",
        "karma-chrome-launcher": "^3.2.0",
        "karma-coverage": "^2.2.1",
        "karma-jasmine": "^5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "postcss": "^8.5.6",
        "prettier": "^3.3.3",
        "prettier-plugin-organize-attributes": "^1.0.0",
        "prettier-plugin-organize-imports": "^4.2.0",
        "prettier-plugin-tailwindcss": "^0.6.14",
        "tailwindcss": "^4.1.12",
        "typescript": "~5.9.2",
        "webpack-bundle-analyzer": "^4.10.2"
    },
    "volta": {
        "node": "22.21.0"
    }
}
